import Cart from '../utilities/cart/CartObserver';

const cart = new Cart();
// Init get the cart on page load
cart.getCart();

// add to the window if access is required outside of source files
window.Tasc_Cart = cart;
